import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  //   CarouselCaption,
} from "reactstrap";

import slide1 from "../assets/images/slider/01.jpg";
import slide2 from "../assets/images/slider/02.jpg";
import slide3 from "../assets/images/slider/03.jpg";
import slide4 from "../assets/images/slider/04.jpg";

const items = [
  {
    src: slide1,
    altText: "Slide 1",
    caption: "Slide 1",
    key: 1,
  },
  {
    src: slide2,
    altText: "Slide 2",
    caption: "Slide 2",
    key: 2,
  },
  {
    src: slide3,
    altText: "Slide 3",
    caption: "Slide 3",
    key: 3,
  },
  {
    src: slide4,
    altText: "Slide 4",
    caption: "Slide 4",
    key: 4,
  },
];

function Slider(args) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {/* <img src={item.src} alt={item.altText} className="img-fluid w-100" /> */}
        <div
          className="slider-bg-image"
          style={{ backgroundImage: `url(${item.src})` }}
        ></div>
        {/* <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        /> */}
      </CarouselItem>
    );
  });

  return (
    <section className="slider-section" id="slider">
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        fade={true}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>
    </section>
  );
}

export default Slider;
